<div
    class="min-w-full flex items-center justify-between gap-2"
    [style.marginTop]="marginTop + 'px'"
    [style.marginBottom]="marginBottom + 'px'">
    <mat-divider class="grow"></mat-divider>
    <ng-content></ng-content>
    <mat-divider class="grow"></mat-divider>
</div>
